// extracted by mini-css-extract-plugin
export default {"smallText":"CommonModal_smallText__nwaiP"};